import { render } from "./OrdersGeneral.vue?vue&type=template&id=16ac1aac"
import script from "./OrdersGeneral.vue?vue&type=script&lang=js"
export * from "./OrdersGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__